import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@communityshare/ui-shared';

export function isInternalPath(url) {
  return typeof url === 'string' && url.startsWith('/') && !url.startsWith('//');
}

/**
 * "Visit the Learning Hub". Internal paths navigate in the app; anything else
 * is a normal link. Renders nothing without a URL.
 */
LearningHubLink.propTypes = {
  url: PropTypes.string,
  icon: PropTypes.oneOf(['right', 'none']),
  onNavigate: PropTypes.func
};

export default function LearningHubLink(props) {
  const { url, icon = 'right', onNavigate } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = useCallback((event) => {
    if (!isInternalPath(url)) return;
    event.preventDefault();
    onNavigate?.();
    navigate(url);
  }, [url, navigate, onNavigate]);

  if (!url) return null;

  return (
    <LinkButton
      label={t('home_videos.section.learning_hub')}
      icon={icon}
      href={url}
      onClick={handleClick}
    />
  );
}
